import Axios from "axios"

export default {

  /**
   * 风控统计
   */
  risk(
    start,
    end,
    project_ids
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/risk_statistic`, {
      params: {
        start,
        end,
        project_ids
      }
    });
  },

  /**
   * 近30天渠道风控趋势
   */
  monthRiskTrend(
    project_ids
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/sign_month_statistic`, {
      params: {
        project_ids
      }
    });
  },

  /**
   * 客流统计
   */
  flow(
    date_start,
    date_end,
    project_ids
  ) {
    return Promise.all(
      [
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/visit/viewPart`, {
          params: {
            date_start,
            date_end,
            project_ids
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/volume/viewPart`, {
          params: {
            date_start,
            date_end,
            project_ids
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/firstVisit/viewPart`, {
          params: {
            date_start,
            date_end,
            project_ids
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/visited/viewPart`, {
          params: {
            date_start,
            date_end,
            project_ids
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/user/volume/viewPart`, {
          params: {
            date_start,
            date_end,
            project_ids
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/externalUser/volume/viewPart`, {
          params: {
            date_start,
            date_end,
            project_ids
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/image/view`, {
          params: {
            date_start,
            date_end,
            project_ids
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/view`, {
          params: {
            date_start,
            date_end,
            project_ids
          }
        })
      ]
    );
  },

  /**
   * 近30天渠道风控趋势
   */
  monthFlowTrend(
    project_ids
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/static/dayGroup/customer/view`, {
      params: {
        project_ids
      }
    });
  },

}